var React = require('react');

function SentCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m186 1061l6 6 13-13","transform":"translate(-184.5-1052.5)","style":{"fill":"none","stroke":"#6dc219","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}}));
}

SentCheck.defaultProps = {"id":"sent-check","viewBox":"0 0 22.031 16"};

module.exports = SentCheck;

SentCheck.default = SentCheck;
